import React, { useState } from 'react';
import {
	Box,
	Heading,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
} from '@chakra-ui/react';

import { UsersIndex } from './users-index';
import { UserTabs } from './user-tabs';
import { Tickets } from './tickets';
import { Consultations } from './consultations';
import { Log } from './log';
import { Settings } from './settings';

export const Admin = ({ user }) => {
	const [userID, setUserID] = useState(-1);
	const [wakeTickets, setWakeTickets] = useState(new Date());
	const [wakeCons, setWakeCons] = useState(new Date());
	const [wakeLog, setWakeLog] = useState(new Date());
	const isAdmin = +user.id < 3;

	return (
		<Tabs isFitted variant="enclosed" pt={6}>
			<TabList
				sx={{
					'@media print': {
						display: 'none',
					},
				}}
			>
				<Tab>Users</Tab>
				<Tab>
					<Box onClick={() => setWakeTickets(new Date())}>Tickets</Box>
				</Tab>
				<Tab>
					<Box onClick={() => setWakeCons(new Date())}>Consultations</Box>
				</Tab>
				<Tab>
					<Box onClick={() => setWakeLog(new Date())}>Log</Box>
				</Tab>
				{isAdmin && (
					<Tab>
						<Box>Settings</Box>
					</Tab>
				)}
			</TabList>

			<TabPanels>
				<TabPanel>
					{userID === -1 ? (
						<UsersIndex {...{ setUserID, admin: user.id }} />
					) : (
						<UserTabs user={{ id: userID, admin: user.id, setUserID }} />
					)}
				</TabPanel>
				<TabPanel>
					<Heading fontSize={'3xl'} mb="6">
						Tickets
					</Heading>
					<Tickets
						admin={user.id}
						{...{ wakeTickets, setWakeTickets, setUserID }}
					/>
				</TabPanel>
				<TabPanel>
					<Consultations
						admin={user.id}
						{...{ wakeCons, setWakeCons, setUserID }}
					/>
				</TabPanel>
				<TabPanel>
					<Log {...{ wakeLog, setWakeLog, setUserID }} />
				</TabPanel>
				{isAdmin && (
					<TabPanel>
						<Settings />
					</TabPanel>
				)}
			</TabPanels>
		</Tabs>
	);
};
